import React from 'react';
export function Footer() {
  return <footer className="w-full bg-[#030308] py-16 px-4 border-t border-white/5" data-id="element-107">
      <div className="max-w-4xl mx-auto text-center" data-id="element-108">
        <div className="text-white text-3xl font-black tracking-widest mb-6 flex items-center justify-center gap-3 drop-shadow-[0_0_15px_rgba(255,255,255,0.2)]" data-id="element-109">
          <span className="text-4xl" data-id="element-110">🧘‍♂️</span> EDULABS™
        </div>

        <p className="text-white/90 text-lg leading-relaxed mb-3 max-w-xl mx-auto font-medium" data-id="element-111">
          El sistema de entrenamiento N.1 para profesionales del Stretching.
        </p>
        <p className="text-white/70 text-sm italic mb-10" data-id="element-112">
          Porque enseñar Stretching no debería costarte tu tiempo personal.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-6 text-sm text-white/80 mb-10" data-id="element-113">
          <span className="hover:text-white transition-colors cursor-pointer flex items-center gap-2" data-id="element-114">
            <span data-id="element-115">📧</span> soporte.edulabs@gmail.com
          </span>
          <span className="hidden sm:inline text-white/40" data-id="element-116">•</span>
          <span className="hover:text-white transition-colors cursor-pointer flex items-center gap-2" data-id="element-117">
            <span data-id="element-118">🌐</span> www.edulabs.online
          </span>
        </div>

        <div className="h-px bg-gradient-to-r from-transparent via-white/10 to-transparent mb-8 w-full max-w-lg mx-auto" data-id="element-119" />

        <p className="text-white/60 text-xs tracking-wider" data-id="element-120">
          © EDULABS™ 2026 — Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}